import type { RouteContext } from '@qse/realtime'
import { useLocation } from 'react-router-dom'

/**
 * Hook to get current route context for admin app
 */
export function useRouteContext(): RouteContext {
  const location = useLocation()

  const pathname = location.pathname
  const searchParams = new URLSearchParams(location.search)

  // Extract search filters from URL
  const search = searchParams.get('query') || ''
  const status = searchParams.get('status') || ''
  const role = searchParams.get('role') || ''
  const plan = searchParams.get('plan') || ''

  // Admin route detection
  if (pathname.startsWith('/dashboard/management/users')) {
    return {
      route: 'admin-users',
      filters: {
        search: search || undefined,
        status: status || undefined,
        role: role || undefined,
      },
    }
  }

  if (pathname.startsWith('/dashboard/management/tenants')) {
    return {
      route: 'admin-tenants',
      filters: {
        search: search || undefined,
        status: status || undefined,
        plan: plan || undefined,
      },
    }
  }

  if (pathname.startsWith('/billing')) {
    return {
      route: 'admin-billing',
      filters: {
        search: search || undefined,
        status: status || undefined,
      },
    }
  }

  if (pathname.startsWith('/dashboard/management/plan')) {
    return {
      route: 'admin-plans',
      filters: {
        search: search || undefined,
        status: status || undefined,
      },
    }
  }

  if (pathname.startsWith('/dashboard/management/api-keys')) {
    return {
      route: 'admin-api-keys',
      filters: {
        search: search || undefined,
        status: status || undefined,
      },
    }
  }

  if (pathname.startsWith('/dashboard/management/reseller')) {
    return {
      route: 'admin-resellers',
      filters: {
        search: search || undefined,
        status: status || undefined,
      },
    }
  }

  // Default admin dashboard route
  if (pathname.startsWith('/dashboard') || pathname === '/') {
    return {
      route: 'admin-dashboard',
      filters: {
        search: search || undefined,
      },
    }
  }

  // Fallback
  return {
    route: 'admin-unknown',
    filters: {},
  }
}
